import React, { useEffect, useState } from 'react';
import { Table, Row, Col } from "react-bootstrap";
import { ConsultDetallesReinsc } from "../../funciones/AdmisionFunction";

const DatosInscripcion = (props) => {
    const [materiasInscritas, setMateriasInscritas] = useState([]);
    const [valorUc, setValorUc] = useState("");
    const [preloadInsc, setPreloadInsc] = useState({icon: "fa fa-spinner fa-spin", text: "Buscando materias inscritas"});
    const [uc, setUc] = useState(0);

    useEffect(() => {
        ConsultDetallesReinsc (props.idEst, (resp)=> {
            if (resp[2].length === 0){
                setPreloadInsc({icon: "fa fa-times", text: "Este estudiante no tiene materias inscritas"})
            }else{
                setPreloadInsc({icon: "", text: ""})
            }
            setMateriasInscritas(resp[2])
            setValorUc(resp[3])

            let cantidad = 0;
            for (let i in resp[2]){
                cantidad+= parseInt(resp[2][i].u_c)
            }
            setUc(cantidad)
        })
    }, []);

    const styles = { padding: 5, fontSize: 12 }

    let materiasInsc = () => {
        if (materiasInscritas.length === 0) return (
            <tr>
                <td colSpan={6} align="center"><i className={preloadInsc.icon}></i> {preloadInsc.text}</td>
            </tr>
        )

        if (props.EstCuenta === false) return (
            materiasInscritas.map (option => (
                <tr key = {option.id}>
                    <td style={styles}>{option.materia_name}</td>
                    <td style={styles} align="center">{option.nombre}</td>
                    <td style={styles} align="center">{option.tipoev_name}</td>
                    <td style={styles} align="center">{option.semestre_name}</td>
                    <td style={styles} align="center">{option.u_c}</td>
                    <td style={styles} align="center"> No Disponible</td>
                </tr>
            ))
        )

        return (
            materiasInscritas.map (option => (
                <tr key = {option.id}>
                    <td style={styles}>{option.materia_name}</td>
                    <td style={styles} align="center">{option.nombre}</td>
                    <td style={styles} align="center">{option.tipoev_name}</td>
                    <td style={styles} align="center">{option.semestre_name}</td>
                    <td style={styles} align="center">{option.u_c}</td>
                    <td style={styles} align="center">{(option.u_c * valorUc).toFixed(2)} Bs.</td>
                </tr>
            ))
        )
    }

    let campo = (campo) => {
        if (campo === null || campo === "") return "NO DISPONIBLE";
        return campo;
    }

    return(
        <React.Fragment>
            <Row>
                <Col md = {6}>Email: <span className="text-primary"><strong>{props.email}</strong></span></Col>
                <Col md = {6} align="right"><span className="text-primary"><strong>UNIDADES DE CRÉDITO INSCRITAS: <span className="custom-alert-info" style={{fontSize: 16}}>{uc}</span></strong></span></Col>
                <Col md = {2}>Celular:</Col>
                <Col md = {10}><span className="text-danger"><strong>{campo(props.cel)}</strong></span></Col>
                <Col md = {2}>Teléfono:</Col>
                <Col md = {10}><span className="text-danger"><strong>{campo(props.tlf)}</strong></span></Col>
                <Col md = {2}>Dirección:</Col>
                <Col md = {10}><span className="text-danger"><strong>{campo(props.dir)}</strong></span></Col>
            </Row>
            <div className="table-responsive" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: "50vh"}}>
                <Table striped hover bordered>
                    <tbody>
                        <tr className="custon-back-color">
                            <td align="center" width="35%" style={styles}><strong>Materia</strong></td>
                            <td width="10%" style={styles}><strong>Sección</strong></td>
                            <td align="center" width="15%" style={styles}><strong>Modalidad</strong></td>
                            <td align="center" width="15%" style={styles}><strong>Semestre</strong></td>
                            <td align="center" width="10%" style={styles}><strong>U.C.</strong></td>
                            <td align="center" width="15%" style={styles}><strong>Monto</strong></td>
                        </tr>
                        {materiasInsc()}
                    </tbody>
                </Table>
            </div>
        </React.Fragment>
    )
}

export default DatosInscripcion;


// WEBPACK FOOTER //
// ./src/views/Inscripcion/DatosInscripcion.jsx